import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { InformacionBarComponent } from './informacion-bar/informacion-bar.component';
import { RedimirEnfermeraAtenderComponent } from './redimir-enfermera-atender/redimir-enfermera-atender.component';
import { RedimirMedicoAtenderComponent } from './redimir-medico-atender/redimir-medico-atender.component';
import { RedimirMedicoVistaComponent } from './redimir-medico-vista/redimir-medico-vista.component';
import { RedimirEnfermeraVistaComponent } from './redimir-enfermera-vista/redimir-enfermera-vista.component';
import { CanjeMedicoSolicitudComponent } from './canje-medico-solicitud/canje-medico-solicitud.component';
import { CanjeMedicoAtenderComponent } from './canje-medico-atender/canje-medico-atender.component';
import { CanjeMedicoVistaComponent } from './canje-medico-vista/canje-medico-vista.component';
import { RedimirSupervisorVistaComponent } from './redimir-supervisor-vista/redimir-supervisor-vista.component';
import { RedimirSupervisorAtenderComponent } from './redimir-supervisor-atender/redimir-supervisor-atender.component';

@NgModule({
  declarations: [
    InformacionBarComponent,
    RedimirEnfermeraAtenderComponent,
    RedimirMedicoAtenderComponent,
    RedimirMedicoVistaComponent,
    RedimirEnfermeraVistaComponent,
    CanjeMedicoSolicitudComponent,
    CanjeMedicoAtenderComponent,
    CanjeMedicoVistaComponent,
    RedimirSupervisorVistaComponent,
    RedimirSupervisorAtenderComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    InputNumberModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule
  ],
  exports: [InformacionBarComponent],
  providers: []
})
export class ComponentsModule { }